<div class="estimate-card mb-3 p-3">
  <div class="estimate-info">
    <div class="estimate-icon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 20.8002V2.6002C3 2.48353 3.05 2.40436 3.15 2.3627C3.25 2.32103 3.34167 2.34186 3.425 2.4252L4.15 3.1502C4.25 3.2502 4.36667 3.3002 4.5 3.3002C4.63333 3.3002 4.75 3.2502 4.85 3.1502L5.65 2.3502C5.75 2.2502 5.86667 2.2002 6 2.2002C6.13333 2.2002 6.25 2.2502 6.35 2.3502L7.15 3.1502C7.25 3.2502 7.36667 3.3002 7.5 3.3002C7.63333 3.3002 7.75 3.2502 7.85 3.1502L8.65 2.3502C8.75 2.2502 8.86667 2.2002 9 2.2002C9.13333 2.2002 9.25 2.2502 9.35 2.3502L10.15 3.1502C10.25 3.2502 10.3667 3.3002 10.5 3.3002C10.6333 3.3002 10.75 3.2502 10.85 3.1502L11.65 2.3502C11.75 2.2502 11.8667 2.2002 12 2.2002C12.1333 2.2002 12.25 2.2502 12.35 2.3502L13.15 3.1502C13.25 3.2502 13.3667 3.3002 13.5 3.3002C13.6333 3.3002 13.75 3.2502 13.85 3.1502L14.65 2.3502C14.75 2.2502 14.8667 2.2002 15 2.2002C15.1333 2.2002 15.25 2.2502 15.35 2.3502L16.15 3.1502C16.25 3.2502 16.3667 3.3002 16.5 3.3002C16.6333 3.3002 16.75 3.2502 16.85 3.1502L17.65 2.3502C17.75 2.2502 17.8667 2.2002 18 2.2002C18.1333 2.2002 18.25 2.2502 18.35 2.3502L19.15 3.1502C19.25 3.2502 19.3667 3.3002 19.5 3.3002C19.6333 3.3002 19.75 3.2502 19.85 3.1502L20.575 2.4252C20.6583 2.34186 20.75 2.32103 20.85 2.3627C20.95 2.40436 21 2.48353 21 2.6002V20.8002C21 21.0335 20.9 21.1919 20.7 21.2752C20.5 21.3585 20.3167 21.3169 20.15 21.1502L19.85 20.8502C19.75 20.7502 19.6333 20.7002 19.5 20.7002C19.3667 20.7002 19.25 20.7502 19.15 20.8502L18.35 21.6502C18.25 21.7502 18.1333 21.8002 18 21.8002C17.8667 21.8002 17.75 21.7502 17.65 21.6502L16.85 20.8502C16.75 20.7502 16.6333 20.7002 16.5 20.7002C16.3667 20.7002 16.25 20.7502 16.15 20.8502L15.35 21.6502C15.25 21.7502 15.1333 21.8002 15 21.8002C14.8667 21.8002 14.75 21.7502 14.65 21.6502L13.85 20.8502C13.75 20.7502 13.6333 20.7002 13.5 20.7002C13.3667 20.7002 13.25 20.7502 13.15 20.8502L12.35 21.6502C12.25 21.7502 12.1333 21.8002 12 21.8002C11.8667 21.8002 11.75 21.7502 11.65 21.6502L10.85 20.8502C10.75 20.7502 10.6333 20.7002 10.5 20.7002C10.3667 20.7002 10.25 20.7502 10.15 20.8502L9.35 21.6502C9.25 21.7502 9.13333 21.8002 9 21.8002C8.86667 21.8002 8.75 21.7502 8.65 21.6502L7.85 20.8502C7.75 20.7502 7.63333 20.7002 7.5 20.7002C7.36667 20.7002 7.25 20.7502 7.15 20.8502L6.35 21.6502C6.25 21.7502 6.13333 21.8002 6 21.8002C5.86667 21.8002 5.75 21.7502 5.65 21.6502L4.85 20.8502C4.75 20.7502 4.63333 20.7002 4.5 20.7002C4.36667 20.7002 4.25 20.7502 4.15 20.8502L3.85 21.1502C3.68333 21.3169 3.5 21.3585 3.3 21.2752C3.1 21.1919 3 21.0335 3 20.8002ZM7 17.0002H17C17.2833 17.0002 17.5208 16.9044 17.7125 16.7127C17.9042 16.521 18 16.2835 18 16.0002C18 15.7169 17.9042 15.4794 17.7125 15.2877C17.5208 15.096 17.2833 15.0002 17 15.0002H7C6.71667 15.0002 6.47917 15.096 6.2875 15.2877C6.09583 15.4794 6 15.7169 6 16.0002C6 16.2835 6.09583 16.521 6.2875 16.7127C6.47917 16.9044 6.71667 17.0002 7 17.0002ZM7 13.0002H17C17.2833 13.0002 17.5208 12.9044 17.7125 12.7127C17.9042 12.521 18 12.2835 18 12.0002C18 11.7169 17.9042 11.4794 17.7125 11.2877C17.5208 11.096 17.2833 11.0002 17 11.0002H7C6.71667 11.0002 6.47917 11.096 6.2875 11.2877C6.09583 11.4794 6 11.7169 6 12.0002C6 12.2835 6.09583 12.521 6.2875 12.7127C6.47917 12.9044 6.71667 13.0002 7 13.0002ZM7 9.0002H17C17.2833 9.0002 17.5208 8.90436 17.7125 8.7127C17.9042 8.52103 18 8.28353 18 8.0002C18 7.71686 17.9042 7.47936 17.7125 7.2877C17.5208 7.09603 17.2833 7.0002 17 7.0002H7C6.71667 7.0002 6.47917 7.09603 6.2875 7.2877C6.09583 7.47936 6 7.71686 6 8.0002C6 8.28353 6.09583 8.52103 6.2875 8.7127C6.47917 8.90436 6.71667 9.0002 7 9.0002Z"
          fill="#42887D"
        />
      </svg>
    </div>
    <div class="estimate-text">
      <h6 class="text-body1 font-bold">Invoice Generate</h6>
      <p class="text-body2">
        Please genrate invoice to customer recive invoice
      </p>
      <div class="row">
        <input class="form-control" placeholder="Enter Invoce Number" type="text" [(ngModel)]="fileName" />
      </div>
    </div>
  </div>
  <button
    class="btn btn-primary"
    [disabled]="generating || !fileName"
    (click)="onGenerateOrUpdatePdf()"
  >
    Invoice Generate
  </button>
</div>

<div #lrTemplate class="lr-template lr-offscreen">
<body style="margin: 0; padding: 0px; font-family: Arial, sans-serif; font-size: 12px; color: #000; background: #fff;">
    <table style="width: 100%; max-width: 750px; margin: 0 auto; border-collapse: collapse; background: #fff; page-break-inside: avoid;">
        <tr>
            <td style="padding: 0;">
                <table style="width: 100%; border-collapse: collapse; background: #f0f4f8; padding: 15px;">
                    <tr>
                        <td style="width: 70%; vertical-align: middle; padding: 12px;">
                            <div style="font-size: 24px; font-weight: bold; color: #1e4a6b; margin-bottom: 5px;">Always Roadways Private Limited</div>
                            <div style="font-size: 10px; line-height: 1.6; color: #333;">
                                <strong>GSTIN:</strong> 24ABECA2356H1ZX | <strong>PAN:</strong> ABECA2356H ✉ info@alwaysroadways.in  ☎ +91 99094 01001<br>
                                📍 G-5 Siromany 142, B/h Real Plaza, Nr. Omkar CNG Pump, Lalpar, Morbi – 363042 (Guj.)
                            </div>
                        </td>
                        <td style="width: 30%; text-align: right; vertical-align: middle; padding: 12px;">
                            <img src="assets/images/tiles_drop_logo.png">
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
         <tr>
            <td style="padding: 0;">
                <table style="width: 100%; border-collapse: collapse; ">
                    <tr>
                        <td style="width: 100%; text-align: right; vertical-align: middle; padding: 0px;">
                            <div style="background: #E6EDF0; padding: 8px; text-align: center; font-size: 18px; font-weight: bold; color: #004B64; margin-top: 8px; ">
            FREIGHT INVOICE
        </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                        <td style="width: 48%; vertical-align: top; padding-right: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                                <tr>
                                    <td style="padding: 8px 10px;">
                                        <div style="font-weight: bold; margin-bottom: 5px;">{{orderData?.orderBy?.companyName}}</div>
                                        <!-- <div style="font-size: 10px; line-height: 1.6;">
                                            14TH FLOOR, SHRI NAMAN TOWER CHSL B-1401, S V ROAD MUMBAI SUBURBAN, MAHARASHTRA, 400067<br>
                                            <strong>GSTIN:</strong> 27AABCU9603R1ZM <strong>Mobile:</strong> +91 97699 51372
                                        </div> -->
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 2%;"></td>
                        <td style="width: 48%; vertical-align: top; padding-right: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                                <tr>
                                    <td style="padding: 8px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;">CONSIGNEE (RECEIVER)</td>
                                </tr>
                                <tr>
                                    <td style="padding: 8px 10px;">
                                        <div style="font-size: 10px; line-height: 1.6; display: flex; justify-content: space-between;">
                                            <strong>Invoice Date<br>{{ today | date : 'dd/MM/yyyy' }}</strong> <strong>Invoice No<br>{{ fileName }}</strong> <strong>Vehicle Number<br>{{truckNumber}}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #000; page-break-inside: avoid;">
                    <tr style="background: #1e5570; color: #fff;">
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 10%; text-align: center; font-weight: bold;">SR No</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 10%; font-weight: bold;">L.R. NO.</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 28%; text-align: center; font-weight: bold;">Consigner</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 15%; text-align: center; font-weight: bold;">Product </td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 8%; text-align: center; font-weight: bold;">Delivery</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 8%; text-align: center; font-weight: bold;">Rate</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 8%; text-align: center; font-weight: bold;">Qty</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 8%; text-align: center; font-weight: bold;">Weight(KG)</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 8%; text-align: center; font-weight: bold;">Freight</td>
                    </tr>
                     <ng-container
          *ngFor="let suborder of orderData?.subOrders; let so = index; let isFirst = first"
        >
              <ng-container *ngIf="isFirst">
                {{setTruckNumber(suborder?.truckAssignment?.truckNo)}}
              </ng-container>
        <ng-container *ngIf="orderData?.type === 'full-load'">
          <ng-container
            *ngFor="let delivery of suborder.deliveries; let di = index"
          >
            <tr *ngFor="let it of delivery.items; let itt = index">
                  
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">
                           {{ getSerialNumber(so, di, itt) }}
                        </td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1;">{{ suborder?.truckAssignment?.lrNumber }}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ suborder?.pickup?.address?.companyName }}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{it?.product?.name}} {{ it?.product?.subItems?.name ? '- ' + it?.product?.subItems?.name : '' }}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{delivery?.address?.companyName}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{getRate(it)}}</td>
                        <!-- <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{suborder?.productDifferences?.dispatched[0]?.qty}}</td> -->
                        <!-- <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{suborder?.productDifferences?.dispatched[0]?.weight}}</td> -->
                        <!-- <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{suborder?.productDifferences?.dispatched[0]?.weight}}</td> -->
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{getQty(it,suborder?.productDifferences)}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{getWeight(it, suborder?.productDifferences)}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{getPrice(it, getRate(it),suborder?.productDifferences)}}</td>
                 
                      </tr>
                    </ng-container>
          
          </ng-container>
        <ng-container *ngIf="orderData?.type === 'part-load-door' || orderData?.type === 'part-load-office'">
            <tr *ngFor="let it of suborder?.pickup?.items; let itt = index">
                  
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">
                           {{ getPartLoadSerialNumber(so,  itt) }}
                             <!-- {{itt + 1}} -->
                        </td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1;">{{ suborder?.truckAssignment?.lrNumber }}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ suborder?.pickup?.address?.companyName }}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{it?.product?.name}} {{ it?.product?.subItems?.name ? '- ' + it?.product?.subItems?.name : '' }}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{orderData?.sharedDelivery?.address?.companyName }}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{getRate(it)}}</td>
                        <!-- <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{suborder?.productDifferences?.dispatched[0]?.qty}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{suborder?.productDifferences?.dispatched[0]?.weight}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{suborder?.productDifferences?.dispatched[0]?.weight}}</td> -->
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{getQty(it, suborder?.productDifferences)}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{getWeight(it, suborder?.productDifferences)}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{getPrice(it, getRate(it),suborder?.productDifferences)}}</td>
                 
                      </tr>
                    </ng-container>
          </ng-container>
    
                </table>
            </td>
        </tr>

        <tr>
            <td style="padding: 0; padding-top: 0px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #000; page-break-inside: avoid;">
                    <tr>
                        <td style="width: 71%; padding: 8px; border: 1px solid #B3C9D1; text-align: left; vertical-align: top;">
                            <!-- <p style="padding: 8px; margin: 0; ">Amount in Words: Seventy-one thousand three hundred ninety-two</p> -->
                            <p style="padding: 8px; margin: 0;">Remark:</p>    
                        </td>
                        <td style="width: 27%; padding: 0px; border: 1px solid #B3C9D1; text-align: center;">
                            <table style="width: 100%; font-size: 11px;">
                        <tbody><tr>
                            <td style="padding: 8px 15px; border-bottom: 1px solid #B3C9D1; text-align: left;">Total</td>
                            <td style="padding: 8px 15px; border-bottom: 1px solid #B3C9D1; text-align: right; font-weight: bold;">{{ orderData?.totals?.productAmount }}</td>
                        </tr>
                        <ng-container *ngFor="let item of orderData?.otherCharges; let i = index">
                             <tr>
                            <td style="padding: 8px 15px; border-bottom: 1px solid #B3C9D1; text-align: left;">{{item?.label}}</td>
                            <td style="padding: 8px 15px; border-bottom: 1px solid #B3C9D1; text-align: right; font-weight: bold;">{{ item?.charge }}</td>
                        </tr>
                        </ng-container>
                        <tr>
                            <td style="padding: 8px 15px; text-align: left;  font-weight: bold;">Grand Total:</td>
                            <td style="padding: 8px 15px; text-align: right;  font-weight: bold;">{{ orderData?.totals?.amount }}</td>
                        </tr>
                    </tbody></table>
                        </td>

                    </tr>

                </table>
            </td>

         <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                    <tr>
                        <td style="padding: 6px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;" colspan="4">BANK DETAILS FOR PAYMENT</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Bank Name</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Account Name</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Account Number</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">IFSC Code</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">HDFC Bank</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">Always Roadways Pvt Ltd</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">50200012345678</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">HDFC0001234</td>
                    </tr>
                </table>
            </td>
        </tr>

        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                    <tr>
                        <td style="padding: 6px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;" colspan="4">Tax on this supply is payable by the recipient under Reverse Charge (RCM).</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 10px; font-size: 10px; line-height: 1.6;">
                           <strong>GTA Service: </strong> This invoice is issued for Goods Transport Agency (GTA) service under CGST Act, 2017.<br>
                            <strong>GST under RCM:</strong> GST @ 5% is payable by the recipient under Reverse Charge as per Sec. 9(3) of CGST Act.<br>
                           <strong>Transporter Liability:</strong> Transporter is not responsible for loss, damage, delay, accident, fire, flood, strike, or natural calamity.<br>
                           <strong>Freight Charges:</strong> Freight charges are as agreed and final, unless otherwise agreed in writing. Payment Terms: Payment as per To Pay / TBB / Paid terms. Delayed payment may attract charges.<br>
                            <strong>Jurisdiction & Payment:</strong>  All disputes subject to Morbi (Gujarat) jurisdiction. Payment to Always Roadways Pvt Ltd only.
                        </td>   
                    </tr>
                </table>
            </td>
        </tr>
        
        <tr>
            <td style="padding: 8px 0;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                        <td style="width: 70%; vertical-align: bottom; padding: 10px 0;">
                            <div style="font-size: 10px; font-style: italic; text-align: center;">
                                This is a computer-generated freight invoice. No physical signature is required.
                            </div>
                        </td>
                        <td style="width: 30%; text-align: right; vertical-align: bottom; padding: 10px 0;">
                          <img
                        src="assets/images/signature.png"
                        alt=""
                        style="width: 150px"
                      />  
                          <div style="border-top: 1px solid #000; padding-top: 5px; margin-top: 10px; text-align: center; font-size: 11px; font-weight: bold;">
                                Authorised Signatory<br>
                                <span style="font-size: 10px; font-weight: normal;">Always Roadways Pvt Ltd</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</div>
